import CovidScreeningMetadataLang from '@/lang/covid-screening-metadata/CovidScreeningMetadataLang';
import RegionMetadataLang from '@/lang/region/RegionLang';
import InputValidationAccessibilityLang from '@/lang/input-validation-accessibility/InputValidationAccessibilityLang';

export default {
    en: {
        base: {
            home: 'Home',
            joinUs: 'Contact Us',
            btnSubmit: 'Submit',
            btnSubmitAriaLabel: 'Submit and book the appointment.',
            close: 'I Understand',
            delete: 'Delete',
            print: 'Print',
            noData: 'No data available',
            continue: 'Next',
            previous: 'Previous',
            cancel: 'Cancel',
            between: 'Between',
            yes: 'Yes',
            no: 'No',
            na: 'Not Applicable or I don\'t know',
            iDontKnow: 'I don\'t know',
            noAnswer: 'Prefer not to answer',
            choice: 'Please choose',
            timezone: 'My time zone:',
            establishmentTimeZone: 'Time zone:',
            easternTime: 'Eastern Time',
            atlanticTime: 'Atlantic Time',
            zipCode: 'Postal code',
            male: 'Male',
            female: 'Female',
            undefined: 'Unspecified',
            changeVaccineType: 'Change vaccine type',
            backToResults: 'Back to results',
            previousPage: 'Previous page',
            distanceWarning: 'The distances displayed are calculated in a straight line and not according to a route.',
            showMore: 'Show More',
            showLess: 'Show Less',
            phonePrefix: 'Tel.',
            phoneMask: '(###) ### - ####',
            namMask: 'AAAA #### ####',
            dateMask: '####-##-##',
            shortPostalCodeMask: 'A#A',
            postalCodeMask: 'A#A #A#',
            faxPrefix: 'Fax.',
            gapMode: 'GAP Mode',
            errors: {
                requiredField: 'Field is required',
                requiredFieldWithLabel: 'The field "{fieldLabel}" is required',
                requiredFieldConsentForm: 'The confirmation code is required',
                requiredFieldsErrorList: 'List of required fields in error:',
                requiredTermsAndConditions: 'You must accept the terms and conditions',
                requiredRecaptchaToken: 'You must check the box "I am not a robot"',
                failed: 'An error occurred. Please try again.',
                requiredFields: 'Please fill in all mandatory fields',
                cellPhone2short: 'Cellphone number is incorrect',
                phone2short: 'Phone number is incorrect',
                invalidEmail: 'Invalid email format',
                invalidNam: 'This health insurance card is invalid',
                temporaryNAM: 'This health insurance card is temporary',
                invalidUrl: 'Invalid url format',
                invalidZipCode: 'Invalid postal code',
                invalidBirthday: 'Invalid birth date',
                invalidDate: 'Invalid date',
                invalidMonth: 'Invalid month',
                invalidName: 'This name is invalid',
                invalidComments: 'Special characters are not supported',
                zipcodeError: 'Postal code could not be located',
                geolocShortPostcodeFormat: 'The postal code format is not valid',
                invalidConfirmationCode: 'The confirmation code format is not valid',
                errorDialogTitle: 'An error occurred',
                invalidEmployeeNumber: 'Employee number is not of a valid format',
                formQuestion: 'You must answer this question by selecting one of the options above.',
                invalidExtension: 'The extension is invalid',
                scannedRequestMaxSize: 'The file exceeds the limit allowed size of 8 megabytes (MB)',
                invalidDateRange: 'The date must be between {minDate} and {maxDate}',
                travelInvalidDateRange: 'The travel departure date must be between {minDate} and {maxDate}',
                dateFuture: 'The date must be in the future',
                travelDateFuture: 'Travel departure date must be in the future',
                pregnancyDateFuture: 'The due date must be in the future',
                datePast: 'The date must be in the past',
                invalidPrematureBirthWeeks: 'The number of weeks must be between 1 and 32',
            },
            cookieConsent: {
                message: 'This website uses cookies to provide the best possible experience. For more information, visit our: ',
                linkLabel: 'Privacy Policy',
                buttonLabel: 'Ok',
                urlPath: '/confidentialite',
            },
            accessibility: {
                nextStep: 'Continue to the next step',
            },
        },
        header: {
            logoDescription: 'Clic Santé logo. Press Enter to return to Homepage.',
            accessibilitySkipToContentLink: 'Skip to main content',
            subtitle: 'Online appointment booking',
            tabs: {
                takeAppt: 'Appointment Booking',
                reminder: 'Set a Reminder',
                cancelAppt: 'Cancel an Appointment',
            },
            profile: {
                menu: {
                    myProfile: 'My Profile',
                    settings: 'Account Settings',
                    disconnect: 'Disconnect',
                },
                loginText: 'Login',
                loggedText: 'My account',
                createMyAccount: 'Create my account',
            },
            clicsante: {
                title1: 'Book your health',
                title2: ' appointment now!',
                menu: {
                    takeAppt: 'Home',
                    solution: 'Our solutions',
                    cancelAppt: 'Cancel appointment',
                    faq: 'FAQ',
                    join: 'Contact Us',
                    job: 'Job offers',
                    terms: 'Terms and conditions of use',
                    policy: 'Privacy Policy',
                    cookiePolicy: 'Cookie Policy',
                    locale: 'EN',
                },
            },
            logoutConfirmationModal: {
                title: 'Log out from my Clic Santé account',
                text: 'Are you sure you want to log out ?',
                cancel: 'Cancel',
                logout: 'YES, LOG ME OUT',
            },
        },
        footer: {
            website: 'Visit our Website',
            trimoz: {
                depistage: 'depistage.clicsante.ca is an online appointment booking system that allows patients to quickly schedule appointments from the comfort of their own home and easily obtain a confirmation.',
                clicsante: 'Clic Santé is an online appointment booking system that allows patients to quickly schedule appointments from the comfort of their own home and easily obtain a confirmation.',
                pharmaservices: 'Pharmaservices is a an online appointment booking system that allows patients to quickly schedule appointments from the comfort of their own home and easily obtain a confirmation.',
                pharmaprix: 'Only pharmacists are responsible for pharmacy practice',
                uniprix: 'Services in pharmacy are the sole responsibility of pharmacist-owners. Only pharmacists are responsible for pharmacy practice. They only provide related services acting under a pharmacist-owner’s name.',
                allRightsReserved: 'All rights reserved',
            },
            terms: {
                name: 'Terms and conditions of use',
                path: 'terms'
            },
            policy: {
                name: 'Privacy Policy',
                path: 'privacy'
            },
            cookiePolicy: {
                name: 'Cookie Policy',
                path: 'cookie-policy'
            },
            clicsante: {
                mobileMenus: {
                    takeAppt: 'Book <br/>appointment',
                    cancelAppt: 'Cancel<br/>appointment',
                    loginText: 'Login',
                    loggedText: 'My account',
                },
            },
        },
        appt: {
            accessibility: {
                selectPlace: `Select %{placeName} located at %{address}.`,
                unknowPlaceAddress: 'unknow localisation',
                selectService: `Select %{serviceName}. Service description: %{serviceDescription}`,
                unknowServiceDescription: 'No description available.',
                dateDescription: {
                    default: `Select to make an appointment for %{date} for service %{serviceName}.`,
                    alternate: 'Enter the date in Y Y Y Y/M M/D D format.',
                },
                timeDescription: {
                    default: `Select to make an appointment at %{time} on %{date} for service %{serviceName}.`,
                    alternate: `Instead, select the appointment at %{time} on %{date} for service %{serviceName}.`,
                },
                timeDescriptionSelected: {
                    default: `You have chosen to select the appointment at %{time} on %{date} for service %{serviceName}.`,
                },
                stepsIntroduction: {
                    default: 'Start of appointment booking steps%{serviceName} of %{establishmentName} %{selectedPlaceName} (%{establishmentType})%{formattedPlaceAddress}.',
                    serviceName: ' for %{serviceName} service',
                    formattedPlaceAddress: ' located at %{formattedPlaceAddress}',
                },
                continueButtonLabel: 'Go to the next step to continue booking an appointment on {0} at {1} for the {2} service',
                registrationOption: 'Optional step: you can log in or subscribe for a free Clic Santé account to automatically fill in the identification form for each appointment.',
                profileCompletionOption: 'Optional step: you can complete your Clic Santé account registration to pre-fill in the identification form for each appointment.',
                noAvailable: 'no',
                available: '',
                availsCheck: 'There are {0} available appointments for the current selected month of {1}. {2}',
                availsForMonthPrev: 'Press the tab key to continue or press enter to go to the previous month of {0}.',
                availsForMonthNext: 'Press the tab key to select a date on the calendar or press enter to go to the next month of {0}.',
                noAvailsForMonthNext: 'Press enter to go to the next month of {0}.',
                fillFormA11yDirective: 'To fulfill the appointment form without difficulties, navigating by tabulation is recommended. Press the TAB key to advance from an element to another. Press the SHIFT and TAB keys for returning to the previous element. For multiple choices elements, use the arrow navigation to go from a choice to another. Press the SPACE or ENTER key to select the choice.',
            },
            docTitle: 'Book an appointment',
            answerQuestions: 'Answer the questions',
            answeredQuestions: 'Questions',
            chooseService: 'Select a service',
            chooseServiceSub: 'Please select a service',
            answerServiceFilters: 'Answer the questions',
            answeredServiceFilters: 'Questions',
            zipCodeFilter: 'Please enter your postal code',
            answeredZipCodeFilter: 'Postal code',
            enterZipCode: 'Enter your postal code: ',
            choosePlace: 'Select a location',
            choosePlaceSub: 'Please select a location',
            chooseMoment: 'Choose date and time',
            stepProgresss: 'Step @num of @total',
            currentStep: 'Current step',
            completedStep: 'Completed step',
            dataCollectionForm: 'Additional Information',
            dataCollectionAriaDescription: 'Your appointment has been booked. This step is optional and allows the professional to better prepare your appointment.',
            at: ' at ',
            to: ' to ',
            details: 'Details',
            full: 'Full',
            previousMonth: 'Previous Month',
            nextMonth: 'Next Month',
            chooseMomentSub: 'Please select a time and date for your appointment',
            chooseTime: 'Please select a time for your appointment',
            nominativeData: 'Complete your booking',
            nominativeDataSub: 'Please enter your information',
            description: 'Description: ',
            document: 'Refer to the service information document',
            apptTime: 'Appointment time',
            apptTimeTitle: 'Select an appointment time',
            apptDateTitle: 'Select an appointment date',
            loadingTimeSlotsAriaMessage: 'Loading time slots',
            noMetaToDisplay: 'No more info required...',
            duration: 'Duration:',
            minutes: ' minutes',
            price: 'Price: ',
            feesWillApply: 'Fees will apply',
            priceOnDemand: 'Pricing upon request',
            freeOfCharges: 'This service is free of charge',
            upcoming: 'Upcoming',
            complete: 'Full',
            selectMonth: 'Select this month',
            serviceAvailable: 'Service available',
            serviceNotAvailable: 'Service not available',
            topOfStepperForm: 'Top of multi step form',
            targetVaccine: 'The recommended immunization target for your child is from ',
            targetPregnancy: 'The recommended target date for your appointment is from ',
            scannedRequest: 'Take a photo in JPG / PNG format or scan your request in PDF format to send with your appointment. Max. accepted size: 8 megabytes (MB)',
            skipNAM: 'I confirm that I do not have a Quebec Health Insurance Number. I will provide accurate additional information so that I can be identified correctly.',
            tooltips: {
                number: 'You can take more than one appointment',
                time: 'Select the appointment time',
                clickToSee: 'Click to see service details',
                clickToSeePlaceDetails: 'Click to see address',
                scannedRequest: 'The quality of the submitted image is your responsibility.<br /><br />Tips on taking your photo:<br />- Flatten the request, place it on a dark, non-reflective surface <br />- Make sure there is enough light<br />- Ensure the image is clear, and that all information is clearly visible.<br /><br />Inspect the image quality before submitting.',
            },
            dayStatus: {
                availabilities: 'Availabilities',
                toCome: 'Upcoming',
                complete: 'Full',
                kidsAvailabilitiesInsideDelay: 'Target Period',
                kidsAvailabilitiesInsideTolerance: 'Off-target period',
                kidsAvailabilitiesOutsideTolerance: 'Availabilities outside tolerance',
            },
            notifications: {
                deleteSuccess: 'The appointment has been deleted successfully',
                addSuccess: 'The appointment has been added successfully',
                failed: 'An error has occurred. Try Again.',
                dataCollectionForm: 'Please complete the additional information which will be consulted by your pharmacist before your consultation. This will validate your eligibility for care and speed up your access to a healthcare professional.'
            },
            placeholder: {
                email: 'Enter your email',
                confirmEmail: 'Validate your email',
                cellphone: 'Enter your cell phone number',
                firstName: 'Enter the patient\'s first name',
                lastName: 'Enter the patient\'s last name',
                phone: 'Enter your phone number',
                birthday: 'Enter the patient\'s  birth date',
                requester_link_0: 'Myself',
                requester_link_1: 'Someone else or for another patient',
                requester_name: 'Enter the name of the person booking the appointment',
                consentFormConfirmationCode: 'Please enter the consent form confirmation code',
                address: 'Enter the patient\'s address including street, apartment number, city and postal code',
                employeeNumber: 'Unique number that identifies you to your employer',
                employerName: 'Enter the name of your employer',
                workLocation: 'Enter your workplace location',
                jobTitle: 'Enter your job title',
                employeeRegion: 'Enter the employer region (QHR)',
                employeeEstablishment: 'Enter the employer establishment',
                employeeCategory: 'Enter the employee category',
            },
            hints: {
                cellphone: 'Enter your cellphone number if you wish to receive SMS notifications (Standard messaging fees may apply)',
            },
            labels: {
                employerRegion: 'Employer region',
            },
            errors: {
                apptDate: 'Appointment date is required',
                apptTime: 'Appointment time is required',
                phone: 'The phone number is required',
                cellphone: 'The cellphone number is required',
                email: 'The email is required',
                confirmEmail: 'The email confirmation is required',
                emailValid: 'Email format is invalid',
                first_name: 'The first name is required',
                last_name: 'The last name is required',
                birthday: 'Birth date is required',
                birthdayValid: 'Birth date is invalid',
                sendByEmail: 'The email is required to send the message',
                sendBySMS: 'The cellphone number is required to send the SMS',
                invalidAppointmentCount: 'You have exceeded the number of available appointments',
                atLeastOneRequired: 'You need to take at least one appointment',
                noAvailability: 'There are no results that match your search',
                emailNoMatch: 'The "Email" and "Email Confirmation" field values must be the same',
                dynamicServiceFilters: 'No matching service found',
                pregnancy_dpa: 'Expected birth date is required',
                optinNewServiceList: 'Please enter your email to receive our service notifications',
                comments: 'Comments are required',
                resident_first_name: 'Resident first name is required',
                resident_last_name: 'Resident last name is required',
                resident_room_number: 'Resident room number is required',
                resident_birthday: 'Resident birthdate is required',
                scanned_request: 'Scanned document is required',
                requester_link: 'You must select who the appointment is for',
                requester_name: 'You must enter the name of the person booking the appointment',
                travelerCount: 'The number of travelers must be between %min% and %max%',
                nam: 'The field is required. You must enter a valid Quebec Health Insurance number or check the box if you do not have a Quebec Health Insurance number.',
            },
            ah635: {
                healthProblems: 'Have you had COVID-19 or COVID-19 symptoms or have you noticed a recent change in your health?',
                immunosuppression: 'Do you fall into either of the following categories:' +
                    '<div class="pl-4 pb-0">A. You are taking immuno-suppressive drugs.' +
                    '<br/>B. You have a disease that weakens your immune system, such as cancer.</div>',
                allergicReactions: 'Have you ever had an allergic reaction that required a visit to the hospital?\n',
                pregnancyQuestion: '<strong class="font-weight-black">If you are a woman,</strong> are you currently pregnant?',
                bleedingDisorder: 'Do you have a blood clotting problem or are you taking blood thinning medication?',
                immunization: 'Are you in the following category:' +
                    '<div class="pl-4 pb-0">A. Have you been hospitalized and treated for COVID-19 in the last 90 days?</div>',
            },
            as624: {
                healthProblemsQuestion: 'Do you currently have a change in your health status, from your usual status ?',
                immunosuppressionQuestion: 'Do you have a weakened immune system due to a disease or a medication ?',
                allergicReactionsQuestion: 'Do <strong class="font-weight-black">any</strong> of the following apply to you ?' +
                                '<br/>- You have had a severe allergic reaction that required emergency medical attention' +
                                '<br/>- You have had a fairly severe reaction to a vaccine that required medical attention',
                bleedingDisorderQuestion: 'Do you have any bleeding disorders that require medical attention or anticoagulants ?',
                hasBloodTransfusionQuestion: 'Have you received a blood transfusion or immunoglobulin injection in the last 11 months ?',
                pregnancyQuestion: '<strong class="font-weight-black">If you are a woman</strong>, are you pregnant ?',
                lessThanSixMonthsMotherTreatmentQuestion: 'If the patient is an infant less than 6 months of age, did the mother take a biologic agent (e.g., Enbrel, Remicade, Humira) for the treatment of an autoimmune disease (e.g., Crohn’s disease, rheumatoid arthritis, lupus, or psoriasis) during pregnancy ?',
            },
            priorityGroup: {
                healthWorker: 'I am a private sector healthcare worker',
                informalCaregiver: 'I am an informal or family caregiver',
                childcareWorker: 'I am a worker in a licensed early childhood education service or in a school childcare service',
                essentialHealthWorker: 'I am an essential worker',
                chronicDisease: 'I am an adult who has a chronic disease or health problem that increases the risk of complications from COVID-19',
                handicapped: 'I am an adult who has a a motor, intellectual, speech, language, visual, auditory, or other sensory disability or an autism spectrum disorder.',
                handicappedAccompagnator: 'I am a caregiver accompanying an adult who has a a motor, intellectual, speech, language, visual, auditory, or other sensory disability or an autism spectrum disorder.',
                pregnantWoman: 'I am pregnant.',
                publicHealthWorker: 'I am a private or public health and social services worker',
                schoolWorker: 'I am a worker in a school',
                dayCampWorker: 'I am a worker in a summer or day camp',
                seniorsResidence: 'I live in a CHSLD or seniors’ residence',
                astra45: 'I have received 2 doses of AstraZeneca or Covishield',
                nothing: 'I am part of an age group identified for vaccination',
                nothing12: 'I am a person 12 years or older',
                nothing14: 'I am a person 14 years or older',
                nothing18: 'I am a person 18 years or older',
                nothing25: 'I am a person 25 years or older',
                nothing30: 'I am a person 30 years or older',
                nothing35: 'I am a person 35 years or older',
                nothing40: 'I am a person 40 years or older',
                nothing45: 'I am a person 45 years or older',
                nothing50: 'I am a person 50 years or older',
                nothing55: 'I am a person 55 years or older',
                nothing60: 'I am a person 60 years or older',
                nothing65: 'I am a person 65 years or older',
                nothing70: 'I am a person 70 years or older',
                nothing75: 'I am a person 75 years or older',
                nothing80: 'I am a person 80 years or older',
                requiresConsent: 'I make an appointment for a 12 or 13 year old child',
                immunocompromised: 'I am immunocompromised or on dialysis.',
                rpa: 'I am living in a long-term health care centre (CHSLD) or a private senior\'s residence',
                title: 'Are you in one of the following situations:',
                hint: 'Please validate your eligibility if you are a private sector healthcare worker, an essential worker or if you have a chronic illness.',
                vaccineArn: 'I received 2 doses of Astra Zeneca or Covishield and 1 dose of mRNA vaccine (Moderna or Pfizer)',
                none: 'None of the situation applies to me',
                genericVaccine: {
                    title: 'Select the category that applies to you:',
                    ageGroupIdentified: 'I am a person %MIN_AGE_FOR_BOOKING% years of age or older',
                    immunocompromised: 'I am an immunocompromised person 18 years of age or older',
                },
            },
            influenza: {
                healthStatus: 'Do any of the following apply to you:' +
                    '<div class="pl-4 pb-0">A. You have noticed a recent change in your health.' +
                    '<br/>B. You have asthma.' +
                    '<br/>C. You have heavy nasal secretions.' +
                    '<br/>D. You are taking a medication that treats or prevents strokes that occur due to blood clots.</div>',
                isImmunosuppressive: 'Does one of the following situation apply to you?' + '' +
                    '<div class="pl-4 pb-0">A. You are taking immunosuppressive medications.' +
                    '<br/>B. You have a disease that weakens your immune system, such as cancer.</div>',
                hasSevereReaction: 'Have you ever had a severe reaction after receiving a vaccine or other product that required a hospital visit?',
                isPregnant: 'If you are a woman, are you currently pregnant?',
                receivedVaccineLastMonth: 'Have you received a vaccine during the last month?',
                hasImmunocompromisedContact: 'Are you in close contact with an immunocompromised person?',
                peopleWhoLiveWithMe: 'Do you live with? ' +
                    '<div class="pl-4 pb-0">A. An infant under 6 months of age.' +
                    '<br/>B. A person 75 years of age or older.' +
                    '<br/>C. A pregnant woman in her 2nd or 3rd trimester.' +
                    '<br/>D. A person with a chronic illness?</div>',
                hasBloodTransfusion: 'Have you received a blood transfusion or immunoglobulin in the past 11 months? ',
                receivedPneumococcalVaccine: 'Have you received a Pneumococcal vaccine in the past?',
                isHealthCareWorker: 'Are you a health care worker?',
                receivedShinglesVaccine: 'Have you received a Shingles vaccine in the past?',
            },
            vaccineApprehension: {
                title: 'Please indicate which situation applies to you:',
                yes: 'I’m worried about getting vaccinated (example: I’m scared of needles)',
                no: 'I don\'t have any apprehension about vaccination',
            },
            coveredRamq: {
                title: 'Select the category that applies to you:',
                child6MonthTo17Years: 'Children aged 6 months to 17 years with chronic disease',
                adultChronicDisease: 'Adults with chronic disease, including pregnant women in any trimester',
                pregnant: 'Pregnant women in their 2nd and 3rd trimester (14th week and older)',
                person75AndMore: 'Person 75 years of age and older',
                child6MonthTo23Month: 'Children between 6 and 23 months of age',
                person60To74: 'Person between 60 and 74 years of age',
                caregiver: 'Caregiver or person living in the same household as a child under 6 months of age or a person at high risk of hospitalization or death',
                healthCareWorker: 'Health care worker',
                none: 'I don\'t know or none of these categories apply to the patient',
            },
            civilStatusLabel: {
                single: 'Single',
                divorced: 'Divorced',
                married: 'Married',
                'common-law': 'Common-law',
                separated: 'Separated',
                widowed: 'Widowed',
            },
            coadminInjection: {
                title: 'Which vaccines would you like to receive at your appointment?',
                option1: 'COVID-19 and flu vaccines',
                option2: 'COVID-19 vaccine only',
                option3: 'Flu vaccine only',
            },
            relationshipListLabel: {
                father2: 'Father2',
                friend: 'Friend',
                other: 'Other',
                'brother-in-law': 'Brother in law',
                stepmother: 'Stepmother',
                stepfather: 'Stepfather',
                'sister-in-law': 'Sister in law',
                joint: 'Joint',
                daughter: 'Daughter',
                son: 'Son',
                brother: 'Brother',
                grandmother: 'Grandmother',
                grandfather: 'Grandfather',
                mother: 'Mother',
                nephew: 'Nephew',
                niece: 'Niece',
                'little-girl': 'Little girl',
                grandson: 'Grandson',
                dad: 'Dad',
                sister: 'Sister',
                mother2: 'Mother2',
            },
            establishment: {
                type: {
                    pharmacie: 'Pharmacy',
                    clinique_privee: 'Private Clinic',
                    etablissement_de_sante: 'Health Establishment',
                    demo: 'Demo',
                },
            },
        },
        coupon: {
            title: 'Thank you for booking an appointment',
            thanks: 'Thank you for booking an appointment!',
            number: 'Appointment # : ',
            service: 'Service : ',
            resource: 'With :',
            date: 'Date : ',
            hour: 'Hour : ',
            price: 'Cost : ',
            place: 'Location : ',
            address: 'Address : ',
            placeInstructions: 'Important message:',
            instructions: 'Instructions :',
            additionalInformation: 'Additional information:',
            sendByEmail: 'Send by email',
            sendBySMS: 'Send by SMS',
            confirmEmail: 'You will receive this confirmation by email at',
            confirmSMS: 'You will receive this confirmation by SMS at',
            reminderEmail: 'prior to your appointment you will receive a reminder email at',
            reminderSMS: 'prior to your appointment you will receive a reminder text message at',
            virtualReminder: 'prior to your appointment, you will receive a reminder email with the link to the virtual waiting room.',
            smsSent: 'The SMS was sent',
            backToApptBooking: 'Back to Home',
            scannedRequest: 'Scanned document:',
            totalApptBooked: 'Number of appointments booked:',
            nextApptBookNotif: 'On {date}, you will receive a reminder to book your next appointment for: {service}',
            cancelCouponTitle: 'Previous appointment cancelled with success!',
            takeAnotherAppt: {
                title: 'Book another appointment',
                text: 'To book an appointment for a companion or a family member living in the same residence, click on the button below to quickly complete the booking process.',
                btn: 'Book another appointment',
            },
            createProfile: 'Create a Clic Santé profile',
            whyCreateProfile: 'Why should I create a profile?',
        },
        profileAdvantage: {
            title: 'Enhance your experience: Create your Clic Santé profile!',
            subtitle: 'Enjoy many exclusive benefits:',
            actionBtn: 'Create an account for free',
            advantage1: 'View the history of your past appointments',
            advantage2: 'Keep an eye on your upcoming appointments',
            advantage3: 'Modify your personal data and contact information in one place',
        },
        reminder: {
            title: 'Remind me of booking the next appointment',
            reminderInfo: 'Reminder Information',
            remindersInfo: 'Reminders Information',
            maxDate: 'Maximum Date: ',
            addChild: 'Add a reminder',
            submitSuccess: 'Reminders added successfully',
        },
        cancel: {
            cancelTitle: 'Enter your appointment confirmation number in the text field below and click on the "Cancel my appointment" button.',
            cancelSingleTitle: 'Appointment information:',
            cancelMultipleTitle: 'We detected the following appointments were booked at the same time. Check the appointments you want to cancel: ',
            couponLostTitle: 'Did you lose your confirmation number? You can find upcoming appointments from your email.',
            unableToCancel: 'Unable to cancel your appointment? Please call your health center for assistance.',
            couponNumber: 'Coupon number',
            appointmentDate: 'Appointment date',
            appointmentDateRequired: 'Appointment date required',
            groupUuidFromEmail: 'Identification number',
            couponNumberRequired: 'The coupon number is required',
            cancelMyAppointment: 'Cancel my appointment',
            cancelMyAppointments: 'Cancel my appointments',
            getMyAppointment: 'Send me a reminder of my appointments',
            keepMyAppointments: 'Keep my appointments',
            keepMyAppointment: 'Keep my appointment',
            cancelSuccess: 'Appointment successfully cancelled',
            couponLostSuccess: 'Email sent successfully',
            couponLostSuccessNoContent: 'No appointments were found for this email',
            errors: {
                invalidCouponNumber: 'Invalid coupon number',
                appointmentDateInvalid: 'Invalid appointment date',
                couponNotAssociated: 'No appointment associated to this coupon',
            },
            accessibility: {
                prefilledCouponNumber: 'The coupon number has been pre-filled from your appointment email.',
                prefilledAppointmentDate: 'The appointment date has been pre-filled from your appointment email.',
                apptToBeCancelled: 'Click to cancel the appointment on {0} at {1} for the {2} service',
            },
        },
        confirm: {
            confirmSuccess: 'Appointment successfully confirmed',
        },
        joinUs: {
            title: 'Contact Us',
            byPhone: 'By phone:',
            byMail: 'By email: Please fill the form below',
            send: 'Send',
        },
        form: {
            required: 'required',
            optional: 'optional',
            fieldIsRequired: 'The field {0} is required',
            ownerTermsText: '* I understand and accept the <a href="{0}" target="_blank">Terms and Conditions of Use</a> and confirm that I am {1} years of age or older.',
            otherTermsText: '* The patient (or the guardian if the patient is under {1} years old or is incapacitated) understands and agrees to the <a href="{0}" target="_blank">Terms and Conditions of Use</a>.',
            ownerConsentCollectData: '* I understand and agree that my personal information may be disclosed in accordance with the <a href="{0}" target="_blank">Privacy Policy</a>.',
            otherConsentCollectData: '* The patient (or the guardian if the patient is under 14 years old or is incapacitated) understands and agrees that their personal information may be shared in accordance with the <a href="{0}" target="_blank">Privacy Policy</a>.',
            ownerConsentReceiveMarketing: 'I consent to receiving electronic commercial communications from Trimoz by SMS and email. These communications may include the addition of new services in your area. I understand that I may unsubscribe at any time.  Trimoz reserves the right to send operational emails regarding their services.',
            otherConsentReceiveMarketing: 'The patient consents to receiving electronic commercial communications from Trimoz by SMS and email. These communications may include the addition of new services in your area. I understand that I may unsubscribe at any time.  Trimoz reserves the right to send operational emails regarding their services.',
            preTermsText: '* I am {0} years-old or over and I agree with the',
            prePolicyText: 'and the',
            terms: 'Terms of Services',
            policy: 'Privacy Policy',
            termsLink: '/terms',
            policyLink: '/privacy',
            optinNewServiceList: 'Notify me when new services are available in my region',
            birthDate: 'Patient\'s birth date',
            vaccine: 'Vaccine',
            reminderDate: 'Reminder Date',
            firstName: 'Patient\'s first name',
            lastName: 'Patient\'s last name',
            phone: 'Phone',
            email: 'Email',
            message: 'Your message',
            age: 'Age',
            status: 'Status',
            ramq: 'RAMQ',
            adult: 'Adult',
            child: 'Child',
            receiveSMSConfirmation: 'Receive the confirmation by SMS',
            selectNam: 'Select patient',
            consentHints: {
                warning: 'FOLLOW THE INSTRUCTIONS BELOW UNTIL THE END TO GET YOUR FLU VACCINE CONSENT FORM CONFIRMATION CODE.',
                bullet1: '<strong class="font-weight-black"><a href="https://access.eforms.pharmaprix.ca/flu" target="_blank" class="consent-form-link"><span style="color: #cc0a00;">Complete your consent form</span></a>.</strong> The code will be sent to you by email or text message/SMS immediately after completing the form.',
                bullet2: 'Use the same phone number in your appointment request and when filling the consent form.',
                bullet3: 'After retrieving your confirmation code (email or SMS), come back to this window to enter the code in the field above.',
                thanks: '<strong class="font-weight-black">Thank you for completing the form. This will allow us to ensure your safety when receiving your flu shot.</strong>',
            },
            delegatedPiConsent: '* I am legally authorized to provide this personal information or I have obtained the authorization of the person concerned.',
            travelerCount: 'The configuration allows exactly %traveler% traveler(s) per appointment',
            confirmEmail: 'Email Confirmation',
            multiApptLabel: 'Number of appointments desired',
            firstVirtualAppointment: 'This is my first virtual appointment',
            hasntVirtualAccount: 'Click here if you don\'t have a React\'s account',
            appointmentOnReacts: 'The virtual appointment will take place on the ',
            appointmentOnReacts2: '\' platform. You will receive details by email in order to prepare for your virtual appointment.',
            warningNamExpired: 'Beware: You are about to submit an expired health card',
            virtualAccountSelect: {
                label: 'Choose an option for your Reacts\' account',
                items: {
                    true: 'I have a Reacts account',
                    false: 'I do not have a Reacts account',
                },
            },
            reactsRegisterMailInfo: 'Reacts will send you an email to complete the registration of your new account.',
            covid195To11ConfirmConsentToVaccine: {
                title: 'PARENT/GUARDIAN CONSENT (DECISION)',
                text: '<p class="mb-2">As the parent or guardian of a child under the age of 14, you are in charge of vaccination decisions for this child.</p>' +
                    '<p class="mb-2">Explanations for making an informed decision have been provided to you and are available in the email that was sent by your child\'s school.' +
                    '<p class="mb-2">Your consent applies to 2 doses of COVID-19 messenger RNA vaccine (Pfizer) if applicable.</p>' +
                    '<p class="mb-2">If your child has already had positive test to COVID-19, the vaccinator will assess them and then administer the required number of doses; only one dose may be required.</p>' +
                    '<p class="mb-2"><strong>Indicate whether or not your child may be vaccinated against COVID-19 with Pfizer RNA COVID-19 vaccine.</strong></p>' +
                    '<p class="mb-2">You may change your consent at any time. To change your consent, you must contact the CISSS or CIUSSS in your region.</p>',
                refuse: 'I DECLINE to have my child vaccinated against COVID-19',
                refuseError: 'You must consent to have your child vaccinated to complete the booking.',
            },
            covid195To11ConfirmReadDocument: {
                label: 'I have read the leaflet titled “' +
                    '<a href="https://www.quebec.ca/en/health/health-issues/a-z/2019-coronavirus/progress-of-the-covid-19-vaccination/vaccination-children" target="_blank">' +
                    'Vaccination against COVID-19 for children age 5 to 11' +
                    '</a>” form provided by Ministère de la Santé et des Services sociaux and declare that I have fully ' +
                    'understood the information it contains and have obtained appropriate information regarding the ' +
                    'benefits and risks of COVID-19 vaccination as well as the risks of not being vaccinated.',
            },
            patientSelector: {
                otherPatient: 'Other patient',
            },
            errors: {
                piConsentRequired: 'Consent is required',
                birthDate: 'Patient\'s birth date is required',
                birthDateFormat: 'Birth date is not valid',
                dateFormat: 'Date is not valid',
                vaccine: 'Vaccine is required',
                reminderDate: 'Reminder Date is required',
                reminderDateFormat: 'Reminder Date is not valid',
                email: 'Email is required',
                emailFormat: 'Email is not valid ',
                firstName: 'Patient\'s first name is required',
                lastName: 'Patient\'s last name is required',
                phone: 'Phone is required',
                phoneFormat: 'The phone number is incorrect',
                message: 'The message is required',
                virtual_account: 'Email associated to your Reacts account is required',
            },
            phxCovidScreeningReasonQuestion: 'Please indicate the reason for screening:',
            phxCovidExperiencingSymptomQuestion: 'Are you currently experiencing any of the following symptoms?',
            phxCovidAskedToGetAScreeningTestQuestion: 'Have you been asked to get a screening test by a doctor, health care provider, or public health unit?',
            phxCovidTravelledAndAdvisedToQuarantineQuestion: 'In the last 14 days, have you travelled outside of Canada <strong>AND</strong> been advised to quarantine per the <a target="_blank" href="%domain%" class="link1">federal quarantine requirements</a>',
            phxCovidReceivedPositiveExposureNotificationQuestion: 'In the last 14 days, have you received an exposure notification through the <strong>COVID Alert</strong> application?<br/>If you already went for a PCR test and got a negative result, select “No.”',
            phxCovidReceivedPositivePcrTestQuestion: 'Have you received a <strong>positive</strong> PCR test for COVID-19 in the last 90 days?',
            phxCovidScreeningReason0: 'Travel',
            phxCovidScreeningReason0Note: ' (Please read the statement in the grey box below)',
            phxCovidScreeningReason1: 'As a precaution, but I confirm that I have no symptoms',
            phxCovidScreeningReason2: 'Other reasons, but I confirm that I have no symptoms',
            phxCovidScreeningReasonHint: 'It is the traveler\'s responsibility to verify the requirements for the type of COVID-19 test with the country/state/province visited (including stopovers) and the airline. Some transit requirements are applicable.',
            phxCovidExperiencingSymptom0: 'Fever',
            phxCovidExperiencingSymptom1: 'Sudden loss of smell without nasal congestion (with or without loss of taste)',
            phxCovidExperiencingSymptom2: 'Severe fatigue',
            phxCovidExperiencingSymptom3: 'Severe loss of appetite',
            phxCovidExperiencingSymptom4: 'Generalized muscle pain',
            phxCovidExperiencingSymptom5: 'Headache',
            phxCovidExperiencingSymptom6: 'Cough (new or worsened)',
            phxCovidExperiencingSymptom7: 'Shortness of breath or breathing difficulty ',
            phxCovidExperiencingSymptom8: 'Sore throat',
            phxCovidExperiencingSymptom9: 'Runny nose associated with another COVID-19 symptom',
            phxCovidExperiencingSymptom10: 'Nausea',
            phxCovidExperiencingSymptom11: 'Vomiting',
            phxCovidExperiencingSymptom12: 'Diarrhea',
            phxCovidExperiencingSymptom13: 'Stomach pain',
            phxCovidContactWithCovid19PositivePersonHint: 'Close contact is contact of more than 15 minutes, at a distance of less than 2 meters, without a mask (procedure mask).',
            phxCovidScreeningConsentHint: 'Before proceeding with the rapid antigen screening, it is important to understand the following points:',
            phxCovidScreeningConsentPoint1: 'The use of this screening method in symptom-free individuals is indicated by the manufacturer, although not approved by Health Canada.',
            phxCovidScreeningConsentPoint2: 'A person who is not symptomatic and does not meet the criteria for PCR testing may decide to undergo antigen screening to meet a travel requirement or as a precautionary measure before adding people to their circle of contacts (to review situations where <a target="_blank" href="%consentDomain%" data-testid="link1">testing at a government testing center</a> is recommended).',
            phxCovidScreeningConsentPoint3: 'Rapid antigen screening is different from the PCR test. This screening test is less sensitive than the PCR test and provides preliminary results depending at the time it was performed.',
            phxCovidScreeningConsentPoint4: 'A negative result does not rule out a COVID-19 infection.',
            phxCovidScreeningConsentPoint5: 'If you get a preliminary positive result from your screening test, you should isolate yourself at home and follow instructions described on the <a target="_blank" href="%consentDomain%" data-testid="link2">government website</a>',
            phxCovidScreeningConsentLabel: 'By checking this box, I acknowledge that I have read and understood the information above',
            phxCovidScreeningDetailsConsentHint: 'By giving my consent, I confirm that:',
            phxCovidScreeningDetailsConsentPoint1: 'The answers that have been provided to the assessment questions are true to the best of my knowledge, and I acknowledge that if any of these answers are false, I may be held responsible for any harm caused.',
            phxCovidScreeningDetailsConsentPoint2: 'I agree that the answers provided to the assessment questions may be used to evaluate the need for COVID-19 testing; if it is concluded that COVID-19 testing is not warranted, I will accept this recommendation.',
            phxCovidScreeningDetailsConsentPoint3: 'I am aware that no representations or warranties are made as to when the rapid antigen test for COVID-19 is performed. No representation or warranty is made that a negative result on the rapid antigen test for COVID-19 will result in my admission or my agent\'s admission to the jurisdiction to which he/she wishes to travel.',
            phxCovidScreeningDetailsConsentLabel: 'By checking this box, I acknowledge that I have read and understood the above information and give my consent to receive the rapid antigen test for COVID-19 performed by a health care professional employed by a pharmacist owner.<strong> I acknowledge and agree that a pharmacy owner, Pharmaprix, its affiliates, directors, officers, employees, or agents shall not be liable in any way for any loss resulting from my or my agent\'s inability to be admitted, or to be admitted late, to the jurisdiction to which he/she intends to travel.</strong>',
            phxCovidAcceptRiskLabel: 'By checking this box, I acknowledge to have read and understood the information and accept <a target="_blank" href="%consentDomain%">the limitations and risks associated with the rapid screening</a>.  I understand that the pharmacist-owner, Pharmaprix Inc. or Loblaw Inc. does not guarantee or represent the accuracy, efficacy or suitability of the rapid screening. I hereby accept and acknowledge these limitations of the rapid screening and waive any future claims against the pharmacist-owner, Pharmaprix Inc. or Loblaw Inc. regarding the accuracy, efficacy and suitability of the rapid screening.',
            traveler: {
                title: 'Travelers information',
                cardTitle: 'Traveler',
                label: 'Traveler',
                firstName: 'First name',
                lastName: 'Last name',
            },
        },
        errorPage: {
            title: 'Booking appointments online',
            content: 'An error has occurred, contact your administrator to inform them of the situation.',
        },
        notFound: {
            title: 'Page not found (Error 404)',
            content1: 'We are sorry. The search could not be completed.',
            content2: 'The link you entered has been moved or changed',
            thanks: 'Thank you for your understanding.',
            linkToPortal: 'Return to home page',
        },
        sheddingPage: {
            title: 'Appointment booking is temporarily unavailable.',
            content1: 'We invite you to come back in a few minutes.',
            thanks: 'Thank you for your understanding.',
            team: 'The Clic Santé team.',
        },
        appointmentBookedButErrorDisplayingCoupon: {
            title: 'Appointment booked but...',
            message: '<p>A communication error is preventing us from showing you the details of your appointment. You can rest assured that your <strong>appointment has been booked successfully</strong>. Your appointment number is {appointment_number}.</p><p>Please <strong>DO NOT</strong> try to book another copy of this appointment.</p>',
        },
        closestAvailsModal: {
            title: 'Your selection is no longer available',
            timeNoLongerAvail: 'The selected time is no longer available.',
            chooseAnotherAvail: 'Please select another time:',
            returnToCalendar: 'If you need more choices, please return to the calendar. Your personal information will be saved.',
            noClosestAvail: 'There is no more availability for the day you have selected.',
            noClosestAvailGotoCalendar: 'Please return to the calendar to select another day. Your personal information will be saved.',
            toCalendarBtn: 'Return to calendar',
        },
        errors: {
            validation: {
                'invalid-start': {
                    'custom-validator-failure': {
                        title: 'Appointment time unavailable',
                        message: 'The appointment time you selected is not available.<br /><br />' +
                            'Please refresh the page to retrieve up-to-date availabilities.',
                    },
                },
                birthday: {
                    min_age_to_book: {
                        title: 'Important message',
                        message: 'You do not meet the minimum age criteria required to book an appointment.',
                    },
                    max_age_to_book: {
                        title: 'Important message',
                        message: 'You do not meet the maximum age criteria required to book an appointment.',
                    },
                },
            },
            generic: {
                title: 'Error',
                message: 'An error occurred. Please reload the page and try again.',
            },
            forms: {
                expiredToken: {
                    title: 'Error',
                    message: 'The delay for completing the form has expired. However, your appointment remains booked.',
                },
            },
            'service-unavailable': {
                'shedding-page': {
                    title: 'Appointment booking temporarily unavailable',
                    message: 'Booking is temporarily closed due to high traffic. Please come back in a few minutes.',
                },
            },
            invalid: {
                nam: {
                    title: 'Error',
                    message: 'The health insurance number is invalid',
                },
            },
            cancel: {
                couponNotAssociated: {
                    title: 'Not found',
                    message: 'No appointment associated to this coupon',
                },
                couponNotFound: {
                    title: 'Important',
                    message: 'An error has occurred. Your appointment could not be identified for one of the following reasons:' +
                        '<ul class="error-list" style="list-style: disc; margin: 15px 0 15px 15px;">' +
                        '<li>Your confirmation number is incorrect</li>' +
                        '<li>Your confirmation number does not correspond to any future appointment</li>' +
                        '<li>The search operation failed</li>' +
                        '</ul>' +
                        'For more information, please contact your health centre.',
                },
            },
            appointment: {
                forbidden_cancellation_date: {
                    title: 'Cancellation of the appointment',
                    message: 'Your appointment can\'t be cancelled if the appointment date is in the past.',
                },
                forbidden_cancellation_client_state: {
                    title: 'Cancellation of the appointment',
                    message: 'Your appointment can\'t be cancelled because it is already marked as present or absent.',
                },
                unable_to_obtain_lock: {
                    title: 'System overloaded',
                    message: 'A large number of users are currently booking their appointments. Please try again in a few minutes. <br><br>We are sorry for the inconvenience.<br><br>The Clic Santé Team',
                },
                unavailable_availability: {
                    title: 'Oops...',
                    message: 'The date and time of the appointment you selected is no longer available. Please return to the calendar to choose a new date and time.',
                },
                forbidden_confirm_already_cancelled: {
                    title: 'Confirmation of the appointment',
                    message: 'Your appointment can\'t be confirmed because it is already marked as cancelled.',
                },
                forbidden_confirm_past: {
                    title: 'Confirmation of the appointment',
                    message: 'Your appointment can\'t be confirmed because it is in the past.',
                },
            },
            appointments: {
                'duplicate-detected': {
                    title: 'Please note!',
                    message: 'You have already booked an appointment for this service. Be sure to cancel the previous appointment before proceeding with this reservation. Thank you for your time!',
                },
            },
            reacts: {
                errors: {
                    title: 'Communication error',
                    message: 'A communication error with the virtual appointment platform has occurred. Please contact your health care provider.',
                },
            },
            request: {
                timeout: {
                    title: 'Timeout',
                    message: 'The attempted operation could not be resolved in time by the server. Please note that the operation may still have completed in the background. Refresh your browser to validate if the changes applied.',
                },
            },
            availabilities: {
                public: {
                    'nothing-for-day': {
                        title: 'No availability',
                        message: 'No availabilities were found for the selected day',
                    },
                },
            },
            recaptcha: {
                response: {
                    error: {
                        title: 'Error',
                        message: 'The recaptcha validation has expired, please reload the page and try again.',
                    },
                },
            },
            birthdayAndNamAreInvalid: {
                title: 'Error',
                message: 'Your date of birth or your health insurance number is incorrect.',
            },
            validateMinAge: {
                title: 'Error',
                message: 'You\'re not eligible yet to book your appointment.<br /><br />' +
                    'You have selected a vaccine service which does not match your age. Please return to the <a href="https://portal3.clicsante.ca/">Clic Santé</a> homepage and select the correct service.',
            },
            validateMinAgeApp: {
                title: 'Error',
                message: 'In accordance with the Privacy Policy, personal information regarding a minor under the age of 14 will not be collected from them without the consent of the holder of parental authority or the guardian.<br /><br />For more information or assistance, please contact your healthcare facility directly.',
            },
            patient: {
                appointment: {
                    'cannot-link-patient-using-current-user': {
                        title: 'Error',
                        message: 'Please check that you are still connected to your profile account.',
                    },
                },
            },
            screening: {
                preferredCommunicationEmail: {
                    title: 'Important message',
                    message: 'Important! You have indicated that you would like to receive the results of your collection by email. However, one or both of the following fields are incorrect:<br/><br/>' +
                        '<ul style="list-style: circle"><li>The "Email" field has no entry. Please add an email address.</li>' +
                        '<li>The "Communication Preference" field is set to "Phone Call". Please change to "Email".</li></ul>',
                    error: 'You have indicated that you would like to receive the results of your collection by email.',
                },
            },
        },
        metadataScreeningFeesAcknowledged: {
            label: '{0}I understand that I am making an appointment for a private, pharmacy-based testing service and that a fee will be charged on site. This service is different from the government\'s free self-testing program and the free NAAT (PCR) test offered at the testing center. If you have symptoms of COVID-19, we invite you to complete the {1} self-assessment.',
            linkText: 'symptom',
        },
        metadataCovidScreeningEmailConsent: {
            label: 'I have read the declaration of consent and I CONSENT to the center that will handle my COVID-19 screening test sending me the result by email, with the option, depending on my selected preference, of receiving a text message notifying me that the test result was sent by email. If the information concerns my child under 14 years of age, I CONSENT to the center that will handle my child\'s COVID-19 screening test sending me the result by email, with the option, depending on my selected preference, of receiving a text message notifying me that the test result was sent by email.',
        },
        metadataCovidScreeningSecurityConsent: {
            label: '{0}I understand that in choosing to receive the test result by email, with the option of receiving a text message notifying me that the test result will be sent by email, part of my information will leave this secure computer platform and might not benefit from the same security measures or be accessed by third parties.{1}' +
                'I acknowledge that if my email address or telephone number is wrong, my test result could be sent to the wrong email address and that my first and last names could be sent to a wrong telephone number.{2}' +
                'By not consenting to the test result being sent by email, I understand that the transmission of the test result will be sent by telephone.{3}' +
                '{4}',
            linkText: 'Declaration of consent',
        },
        banner: {
            promptLogin: {
                ctaMessage: 'to your Clic Santé account in order to automatically fill in the identification form for each appointment',
                login: 'Login',
                subscribe: 'subscribe',
                or: 'or',
            },
            promptCompleteRegistration: {
                ctaMessage1: 'In order to pre-fill the reservation form, you must ',
                login: 'complete your Clic Santé account registration.',
                ctaMessage2: ' You may also enter your personal information manually. <br /> Once you have completed your account, you can ',
                getUpdatedPatients: 'refresh the reservation form.',
            },
        },
        covidScreeningMetadataLang: {
            ...CovidScreeningMetadataLang.en,
        },
        regionMetadataLang: {
            ...RegionMetadataLang.en,
        },
        coAdministrationFluCovid: {
            metadata: {
                flu: {
                    title: 'I would like to receive the flu (influenza) and COVID-19 vaccines at the same time.',
                    description: 'Flu shots are now available free of charge to the general public. For more information, visit the <a href="https://www.quebec.ca/en/health/advice-and-prevention/vaccination/flu-vaccination-program" target="_blank">Flu Vaccination Program website</a>',
                },
                covid: {
                    title: 'I would like to receive the COVID-19 and flu (influenza) vaccines at the same time.',
                    description: 'Flu shots are now available free of charge to the general public. For more information, visit the <a href="https://www.quebec.ca/en/health/advice-and-prevention/vaccination/flu-vaccination-program" target="_blank">Flu Vaccination Program website</a>',
                },
            },
            couponReminder: '<b class="font-weight-black">Reminder:</b> you have chosen to receive a <u>COVID-19</u> and a <u>flu vaccine</u>. Both vaccines will be administered on the same appointment. No further action is required.',
        },
        accessibility: {
            loadingGeneric: 'Loading results',
        },
        inputValidationAccessibilityLang: {
            ...InputValidationAccessibilityLang.en,
        },
        privacy: {
            title: 'Data Confidentiality',
            text: 'The information you provide here will be treated confidentially and will only be accessible to your pharmacy staff.'
        },
    },
};
